import { IPropStorage } from 'df-prop-storage/prop-storage-types';
import { ReactModel } from '../react-model';

/**
 * @description
 * How does the ReactModel cache plugin work
 * -----------------------------------------
 * 1. On start: load from local storage, and use the old value if not expired.
 * 2. When state changes, save to local storage.
 * When creating the model, use this value for life_circle: "overwrite_old_data",
 *
 * @example
 * //1. create model
 * const modelSample = createModel(...);
 * //2. enable the plugin that can use data updated within 60 minutes
 * ReactModelPlugin_Cache(modelSample, new LocalPropStorage(), 3600);
 *
 * @param model the model to saved in cache
 * @param storage where to store
 * @param key key used in the storage
 * @param expire_seconds if 0, then never expire
 */

export function ReactModelPlugin_Cache<T, K>(model: ReactModel<T>, storage: IPropStorage, key: string, expire_seconds: number) {
	//: ReactModel<T, K & { clear: () => void }> {
	// If already cache enabled, avoid doing it again.
	if ((model as any).__cachedEnabled) return model as any;
	(model as any).__cachedEnabled = true;

	//load model value on start
	loadModel();
	saveModelOnChange();

	//save on change
	function saveModelOnChange() {
		model.addObserver(
			'(RMC33)save-to-storage',
			(state) => {
				storage.setItem(key, {
					state,
					timestamp: Date.now(),
				});
			},
			model.model_id.toString()
		);
	}

	function loadModel() {
		const s = storage.getItem(key);
		try {
			if (s) {
				const obj = s || {};
				if (obj.timestamp) {
					if (!expire_seconds || Date.now() - obj.timestamp < 1000 * expire_seconds) {
						model.setState(obj.state);
					}
				}
			}
		} catch {
			//ignore error if fail to load the model from cache
		}
	}
}
